import React, { Component } from 'react';
import { Field } from 'redux-form';
import * as Form from './formFieldHelpers';
import { HOCFormButtons } from '../ui/buttons';

export default class RequestEndorsement extends Component {
     componentWillMount() {
         const { initialize } = this.props;
         initialize( { type: 'CREATE' } )
    }

    render() {
        const { buttonHandlers } = this.props;

        return (
            <form className="form-standard-profile">
                <div className="row">
                    <h4 className="h4 brand-color col-xs-12">Request an endorsement from...</h4>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <Field
                            name="first_name"
                            label="First Name"
                            placeholder="First Name"
                            component={ Form.textField }
                        />
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <Field
                            name="last_name"
                            label="Last Name"
                            placeholder="Last Name"
                            component={ Form.textField }
                        />
                    </div>
                    <div className="col-xs-12">
                        <Field
                            name="email_address"
                            label="Email address"
                            placeholder="Email address"
                            component={ Form.textField }
                        />
                    </div>
                    <div className="col-xs-12">
                        <HOCFormButtons { ...this.props } { ...buttonHandlers } />
                    </div>
                </div>
            </form>
        )
    }
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/RequestEndorsement.js